module.exports = __webpack_public_path__ + "static/img/logo_samu_.dace5e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_samu_.png
// module id = NRR5
// module chunks = 4